<template>
    <div class="card-json big-card-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_r_json.png" alt="">
                        </div>

                        <h4>JSON API</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <json-header :headers="data.headers"></json-header>
                    <json-request :data-object="data"></json-request>
                    <json-attributes :attribute-fields="data.attributeFields"></json-attributes>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    import jsonHeader from './json-api/json-header'
    import jsonRequest from './json-api/request'
    import jsonAttributes from './json-api/attributes'
    export default {
        name: "card-image-url",
        components:{
            jsonHeader,
            jsonRequest,
            jsonAttributes
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>